import React from 'react'
import { WidgetId } from 'features/types'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { PatchedPostMetricResult } from 'schemas/PostMetricResultSchema'
import styled from 'styled-components'
import { PostMetric } from 'schemas/PostMetricSchema'
import { isDeletedPost, isPodcastPost, isVocPost } from 'utils/postMetricUtil'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { SocialWebPopularPostsWidget } from 'schemas/SocialWebPopularPostsWidgetSchema'
import Divider from 'components/visualization/SoundbiteFrame/Divider'

import { retrievePostMetrics } from '../utils'
import { DeletedPosts, Post, PodcastPost, VocPost } from './components'
import WidgetContext from './widgetContext'

const PostsContainer = styled.div`
  width: 100%;
  height: 100%;
`

interface PopularPostsProps {
  widgetId: WidgetId
  onRowClick?: (targetRow: PostMetric) => void
}
const PopularPosts = ({ widgetId, onRowClick }: PopularPostsProps) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebPopularPostsWidget>(widgetId)
  const widgetData = useDashboardWidgetData<PatchedPostMetricResult>(widgetId)

  const postMetrics = retrievePostMetrics(widgetData) as PostMetric[]
  const normalPosts = postMetrics.filter((postMetric) => !isDeletedPost(postMetric))
  const deletedPosts = postMetrics.filter(isDeletedPost)
  const hasDeletedPosts = deletedPosts.length > 0

  return (
    <WidgetContext.Provider value={{ widgetSetting }}>
      <PostsContainer>
        {normalPosts.map((postMetric, index) => {
          if (isVocPost(postMetric)) {
            return (
              <VocPost
                serialNumber={index}
                key={postMetric.postId}
                data={postMetric}
                onClick={onRowClick}
              />
            )
          }
          if (isPodcastPost(postMetric)) {
            return (
              <PodcastPost
                serialNumber={index}
                key={postMetric.postId}
                data={postMetric}
                onClick={onRowClick}
              />
            )
          }
          return (
            <Post
              serialNumber={index}
              key={postMetric.postId}
              data={postMetric}
              onClick={onRowClick}
            />
          )
        })}
        {hasDeletedPosts && <DeletedPosts serialNumber={normalPosts.length} data={deletedPosts} />}
        <Divider />
      </PostsContainer>
    </WidgetContext.Provider>
  )
}

export default PopularPosts
